import React, {useState} from 'react'
import {Grid, GridColumn, GridRow, Icon} from 'semantic-ui-react'
import PDFDownloadByState from './PDFDownloadByState'
import copyToClipboard from '../../../util/copyToClipboard'
import Modal from '../../common/Modal'
import GroupFields from '../../form/common/fieldgroups/GroupFields'
import useLocalForm from '../../../hooks/useLocalForm'
import {DEFAULT_GROUP_TYPE} from '../../../constant/GROUP_TYPES'
import ReactGA from 'react-ga'

export default function BenAdminAlternateSubmissionModal({trigger}) {
  const {state: formState, dispatch: setFormState, reset} = useLocalForm({
    groupNumber: {
      value: '',
      dirty: '',
      transform: (v) => v.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
    },
    subgroup: {value: ''},
    groupName: {value: '', dirty: ''},
    usState: {value: ''},
    groupType: {value: DEFAULT_GROUP_TYPE},
    error: null
  })

  const [copied, setCopied] = useState(false)

  const queryParams = [
    `groupnumber=${encodeURIComponent(formState.groupNumber.value)}`,
    `groupname=${encodeURIComponent(formState.groupName.value)}`,
    `subgroup=${encodeURIComponent(formState.subgroup.value)}`,
  ].join('&')

  const dispatch = (k, v) => {
    setFormState({key: k, value: v})
  }

  const onChange = (e) => {
    dispatch(
      `${e.target.id}.value`,
      formState[e.target.id].transform ?
        formState[e.target.id].transform(e.target.value) :
        e.target.value
    )
  }

  const onBlur = (e) => {
    dispatch(`${e.target.id}.dirty`, true)
  }

  const copyLink = () => {
    ReactGA.event({
      category: 'paper',
      action: 'benefit-admin-link',
      label: formState.groupNumber.value
    })
    copyToClipboard(link()).then(() => {
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    })
  }

  const link = () => {
    return `${window.location.href}?${queryParams}`
  }

  const content = () => {
    return <Grid container stackable>
      <GridRow className='bottom-padded' centered>
        <GridColumn width={13} textAlign='center'>
          Providing your group number and name will generate an EoI form pre-populated with this information, and will
          help expedite the processing of the application.
        </GridColumn>
      </GridRow>
      <GridRow>
        <GroupFields controlledState={{state: formState, onChange: onChange, onBlur: onBlur}}/>
      </GridRow>
      <GridRow className='bottom-padded'>
        <GridColumn computer={8} tablet={16} mobile={16} textAlign='center'>
          <h5>Email Link</h5>
          <p>Providing the link below, allows any member to fill out an EoI form online. The online form will be
            pre-populated with the group name and number.</p>
          {copied ? <em className='success'>Link Copied</em> : <div
            role='presentation'
            onClick={copyLink}
            onKeyDown={copyLink}
            className='u-link'
          >
            Copy Link <Icon name='copy'/>
          </div>
          }
        </GridColumn>
        <GridColumn computer={8} tablet={16} mobile={16} textAlign='center'>
          <h5>PDF Download</h5>
          <PDFDownloadByState
            state={formState}
            setState={setFormState}
            additionalQueryParams={queryParams}
          />
        </GridColumn>
      </GridRow>
    </Grid>
  }

  return <Modal
    id='ben-admin-paper-form'
    trigger={trigger}
    onClose={reset}
    closeIcon
    closeOnDimmerClick
    trackingName='/paper/benefit-admin'
  >
    {content()}
  </Modal>
}